import React from "react";
import { getProviderDisplayName } from "utils/providers";
import { getProviderInitials, resolveProviderLogo } from "utils/providerLogos";

export default function ProviderLogo({
  provider,
  imgClassName = "provider-logo",
  wrapClassName = "provider-logo-wrap",
  showFallbackText = true,
}) {
  const displayName = getProviderDisplayName(provider);
  const logo = resolveProviderLogo(provider);

  if (logo) {
    return (
      <div className={wrapClassName}>
        <img
          src={logo.src}
          alt={displayName}
          className={`${imgClassName}${logo.invert ? " logo--invert" : ""}`}
          loading="lazy"
          decoding="async"
        />
      </div>
    );
  }

  return (
    <div className="provider-name-fallback">
      <span className="provider-name-fallback__badge">{getProviderInitials(displayName)}</span>
      {showFallbackText && (
        <span className="provider-name-fallback__text">{displayName}</span>
      )}
    </div>
  );
}
